const trashTypeSelect = [
  {
    value: "Plastik",
  },
  {
    value: "Kertas",
  },
  {
    value: "Botol",
  },
  {
    value: "Karet",
  },
  {
    value: "Kaca",
  },
  {
    value: "Kayu",
  },
];

export default trashTypeSelect;
